import React, { useEffect, useState } from "react";
import DataGridDemo from "../components/DataTable";
import Loading from "../components/Loading";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { coursesGetAll } from "../store/CourseSlice";
import { toast } from "react-toastify";
import { Delete } from "@mui/icons-material";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { formRequests } from "../store/requestsSlices";
import {
  deleteRequest,
  emptyCompletedRigisterd,
  requestscomplete,
  requestscompleteFilter,
  getCommissionsByStatus,
} from "../store/requestscompleteSlice";
import * as XLSX from "xlsx";
import Cookies from "js-cookie";
import Pagination from "@mui/material/Pagination";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function CourseComplete() {
  const selectionRows = false;
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const allCompetedCourses = useSelector(
    (state) => state.requestscompleteSlice.allcompleterequests,
  );
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const userRole = Cookies.get("user_role");
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = useState();
  const adminUser = userRole == 0 ? true : false;
  const [dates, setDates] = useState({
    startDate: "",
    endDate: "",
  });
  const navigate = useNavigate();
  const [commissionData, setCommissionData] = useState(null);
  const [openCommissionModal, setOpenCommissionModal] = useState(false);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const handledelete = (reqId) => {
    confirmAlert({
      title: "تاكيد الحذف",
      message: "هل انت متاكد من ذلك",
      buttons: [
        {
          label: "تاكيد",
          onClick: () => {
            setLoading(true);
            dispatch(deleteRequest(reqId))
              .unwrap()
              .then((res) => {
                toast.success("تم المسح بنجاح");
                setLoading(false);
                navigate("/dashboard/course-rigister");
              })
              .catch((err) => {
                toast.error(err.response.data);
                setLoading(false);
              });
          },
        },
        {
          label: "الغاء",
        },
      ],
    });
  };

  var modifiedArray = allCompetedCourses.map((item) => ({
    ...item, // Keep all the existing properties
    courseName: item?.courseModel?.name, // Add courseName property
    markterName: item?.markterModel?.name, // Add markterName property
    orderStatusName: item?.orderStatusModel?.name,
    orderDate: item.timeCreated != null ? item?.timeCreated.split("T")[0] : "",
    orderTime: item.timeCreated != null ? item?.timeCreated.split("T")[1] : "",
    orderChangeDate:
      item.timeStatusChanged != null
        ? item?.timeStatusChanged.split("T")[0]
        : "",
    orderChangeTime:
      item.timeStatusChanged != null
        ? item?.timeStatusChanged.split("T")[1]
        : "",
    iscalled2: item.isCalled ? "تم الاصال" : "لم يتم الاتصال",
  }));

  const coulmns = [
    {
      field: "orderDate",
      headerName: "التاريخ",
      width: 150,
    },
    {
      field: "orderTime",
      headerName: "الوقت",
      width: 150,
    },
    { field: "arName", headerName: "الاسم", width: 150 },
    { field: "phone1", headerName: "الهاتف الاول", width: 150 },
    { field: "phone2", headerName: "الهاتف الثاني", width: 150 },
    {
      field: "courseName",
      headerName: "الكورس",
      width: 150,
    },
    {
      field: "iscalled2",
      headerName: "حاله الاتصال",
      width: 150,
      // renderCell: (params) => (
      //   <div className="">
      //     <span className="">
      //       {params.row.isCalled ? (
      //         <span className="callDone">تم الاتصال</span>
      //       ) : (
      //         <span className="callNotDone">لم يتم الاتصال</span>
      //       )}
      //     </span>
      //   </div>
      // ),
    },
    {
      field: "orderStatusName",
      headerName: "حاله الحجز",
      width: 150,
    },
    {
      field: "orderChangeDate",
      headerName: "تاريخ تأكيد الحجز",
      width: 150,
    },
    {
      field: "orderChangeTime",
      headerName: "وقت تأكيد الحجز",
      width: 150,
    },
    {
      field: "markterName",
      headerName: "المسوق",
      width: 150,
    },
    { field: "education", headerName: "التعليم", width: 150 },
    { field: "country", headerName: "الدوله", width: 150 },
    { field: "city", headerName: "المدينه", width: 150 },
  ];

  if (userRole == 0) {
    coulmns.push({
      field: "actions",
      headerName: "اختيارات",
      width: 150,
      renderCell: (params) => (
        <div className="tableoptions">
          <span className="deleteicon">
            <Delete
              onClick={() => handledelete(params.row.id)}
              style={{ cursor: "pointer" }}
            />
          </span>
        </div>
      ),
    });
  }

  const handleRowSelection = (selectionModel) => {
    setRowSelectionModel(selectionModel);
    // setInputs((prevInputs) => ({ ...prevInputs, district_id: selectionModel }));
    // console.log("Selected Rows:", selectionModel);

    // const selectedRowData = selectionModel.map((selectedId) =>
    //   rows.find((row) => row.id === selectedId)
    // );
    // console.log("Selected Row Data:", selectedRowData);
  };

  useEffect(() => {
    setLoading(true);
    dispatch(
      requestscomplete({
        startDate: dates.startDate,
        endDate: dates.endDate,
        pageNumber: page,
      }),
    )
      .unwrap()
      .then((res) => {
        // toast.success('')
        setLoading(false);
        setPageCount(res.totalPages);
        console.log(res);
      })
      .catch((err) => {
        toast.error(err.response.data);
      });
  }, [dispatch, page]);

  useEffect(() => {
    dispatch(getCommissionsByStatus())
      .unwrap()
      .then((res) => {
        setCommissionData(res);
      })
      .catch((err) => {
        console.error("Error fetching commissions:", err);
      });
  }, [dispatch]);

  const handleOpenCommissionModal = () => {
    setOpenCommissionModal(true);
  };

  const handleCloseCommissionModal = () => {
    setOpenCommissionModal(false);
  };

  const downloadCommissionData = () => {
    if (!commissionData) return;

    const totalNet = commissionData.courses.reduce(
      (total, course) => total + course.coursePrice * course.requestCount,
      0,
    );
    const totalRequests = commissionData.courses.reduce(
      (total, course) => total + course.requestCount,
      0,
    );
    const totalCommission14 = commissionData.courses.reduce(
      (total, course) =>
        total + course.coursePrice * 0.14 * course.requestCount,
      0,
    );
    const avgApiPercentage = (
      (commissionData.totalCommission / totalNet) *
      100
    ).toFixed(2);

    const dataToExport = commissionData.courses.map((course) => ({
      "اسم الكورس": course.courseName,
      "سعر الكورس": course.coursePrice,
      "عدد الطلبات": course.requestCount,
      "إجمالي العمولة (14%)": course.coursePrice * 0.14 * course.requestCount,
    }));

    // Add totals row
    dataToExport.push({
      "اسم الكورس": "الإجمالي الكلي",
      "سعر الكورس": 0,
      "عدد الطلبات": totalRequests,
      "إجمالي العمولة (14%)": totalCommission14,
    });

    downloadExcelFile(dataToExport, "commission_details.xlsx");
  };

  const handelFilterChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setDates((prevInputs) => ({ ...prevInputs, [name]: value }));
  };

  const filterByDate = (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(
      requestscomplete({
        startDate: dates.startDate,
        endDate: dates.endDate,
        pageNumber: 1,
      }),
    )
      .unwrap()
      .then((res) => {
        // toast.success('')
        setLoading(false);
        setPageCount(res.totalPages);
        setPage(1);
      })
      .catch((err) => {
        toast.error(err.response.data);
      });
  };

  const emotyCompleteCourses = () => {
    setLoading(true);
    dispatch(
      emptyCompletedRigisterd({
        startDate: dates.startDate,
        endDate: dates.endDate,
      }),
    )
      .unwrap()
      .then((res) => {
        toast("تم التفريغ بنجاح");
        setTimeout(() => {
          window.location.reload();
          setLoading(false);
        }, 1000);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.response.message);
      });
  };

  const downloadData = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await dispatch(
        requestscompleteFilter({
          startDate: dates.startDate,
          endDate: dates.endDate,
          pageNumber: 1,
        }),
      )
        .unwrap()
        .then((res) => {
          setLoading(true);
          var modifiedArray = res.map((item) => ({
            orderDate:
              item.timeCreated != null ? item?.timeCreated.split("T")[0] : "",
            orderTime:
              item.timeCreated != null ? item?.timeCreated.split("T")[1] : "",
            name: item?.arName,
            firstphone: item?.phone1,
            secondphone: item?.phone2,
            courseName: item?.courseModel?.name, // Add courseName property
            iscalled: "تم الاتصال",
            orderStatus: item?.orderStatusModel?.name,
            markterName: item?.markterModel?.name.split("ليدر")[0],
            LeaderName: item?.markterModel?.name.split("ليدر")[1] || "", // Add markterName property
            customerServiceModel: item?.customerServiceModel?.name,
            ...item, // Keep all the existing properties
          }));

          const filteredRes = modifiedArray.map((item) => {
            // Destructure the object and remove the properties you don't need
            const {
              courseId,
              enName,
              arName,
              phone1,
              phone2,
              customerServiceId,
              orderStatusId,
              markterId,
              courseModel,
              markterModel,
              orderStatusModel,
              customerServiceModel,
              isCalled,
              id,
              timeCreated,
              ...rest
            } = item;
            return rest;
          });

          downloadExcelFile(filteredRes, "filtered_data.xlsx"); // Function to generate Excel data

          // Trigger download
          // downloadExcel(excelData, "data.xlsx");
          setLoading(false);
          // window.location.reload();
        })
        .catch((err) => {
          toast.error(err.response.data);
        });
    } catch (err) {
      toast.error(err.response.data);
      setLoading(false);
    }
  };

  const downloadExcelFile = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    XLSX.writeFile(wb, fileName);
  };

  return (
    <>
      {loading ? <Loading open={true} /> : null}
      <div className="manage_employee">
        {/*<div className="add_button">
          {userRole == 0 ? (
            <Link to="/dashboard/add-new-course">اضافة كورس</Link>
          ) : null}
        </div>*/}

        <div className="table_show table_style">
          <h5>تاكيدات الحجز</h5>

          {commissionData && (
            <div
              className="commission-section d-flex align-items-center justify-content-start"
              style={{
                marginBottom: "20px",
                padding: "15px",
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                gap: "20px",
              }}
            >
              <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                إجمالي العمولات (14%):{" "}
                <span style={{ color: "#1976d2" }}>
                  {commissionData.courses
                    .reduce(
                      (total, course) =>
                        total + course.coursePrice * 0.14 * course.requestCount,
                      0,
                    )
                    .toLocaleString()}{" "}
                  جنيه
                </span>
              </div>
              <button
                className="btn btn_style"
                onClick={handleOpenCommissionModal}
              >
                عرض التفاصيل
              </button>
              <button
                className="btn btn_style mr-2"
                onClick={downloadCommissionData}
                style={{ backgroundColor: "#4caf50", marginRight: "20px" }}
              >
                تحميل العمولات
              </button>
            </div>
          )}

          {/* Commission Details Modal */}
          <Dialog
            open={openCommissionModal}
            onClose={handleCloseCommissionModal}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle
              sx={{
                m: 0,
                p: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              تفاصيل العمولات
              <IconButton
                aria-label="close"
                onClick={handleCloseCommissionModal}
                sx={{ color: (theme) => theme.palette.grey[500] }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {commissionData && (
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 750 }} aria-label="commission table">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#1976d2" }}>
                        <TableCell
                          align="right"
                          sx={{ color: "white", fontWeight: "bold" }}
                        >
                          اسم الكورس
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ color: "white", fontWeight: "bold" }}
                        >
                          سعر الكورس
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ color: "white", fontWeight: "bold" }}
                        >
                          عدد الطلبات
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ color: "white", fontWeight: "bold" }}
                        >
                          نسبة العمولة (14%)
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ color: "white", fontWeight: "bold" }}
                        >
                          إجمالي العمولة (14%)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {commissionData.courses.map((course, index) => {
                        const commission14 =
                          course.coursePrice * 0.14 * course.requestCount;
                        return (
                          <TableRow
                            key={index}
                            sx={{
                              "&:nth-of-type(odd)": {
                                backgroundColor: "#f5f5f5",
                              },
                            }}
                          >
                            <TableCell align="right">
                              {course.courseName}
                            </TableCell>
                            <TableCell align="right">
                              {course.coursePrice.toLocaleString()} جنيه
                            </TableCell>
                            <TableCell align="right">
                              {course.requestCount}
                            </TableCell>

                            <TableCell align="right">14%</TableCell>
                            <TableCell align="right">
                              {commission14.toLocaleString()} جنيه
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                          الإجمالي الكلي
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ fontWeight: "bold" }}
                        ></TableCell>
                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                          {commissionData.courses
                            .reduce(
                              (total, course) => total + course.requestCount,
                              0,
                            )
                            .toLocaleString()}
                        </TableCell>

                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                          14%
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                          {commissionData.courses
                            .reduce(
                              (total, course) =>
                                total +
                                course.coursePrice * 0.14 * course.requestCount,
                              0,
                            )
                            .toLocaleString()}{" "}
                          جنيه
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableContainer>
              )}
            </DialogContent>
            <DialogActions
              sx={{ justifyContent: "space-between", padding: "16px" }}
            >
              <button
                className="btn btn_style"
                onClick={downloadCommissionData}
                style={{ backgroundColor: "#4caf50", padding: "10px 20px" }}
              >
                تحميل البيانات
              </button>
              <button
                className="btn btn_style"
                onClick={handleCloseCommissionModal}
                style={{ backgroundColor: "#f44336", padding: "10px 20px" }}
              >
                إغلاق
              </button>
            </DialogActions>
          </Dialog>

          <div
            className="filter custom_filter"
            style={{ marginBottom: "50px" }}
          >
            <form action="" onSubmit={filterByDate}>
              <div className="form-group">
                <label htmlFor="">تاريخ البدايه </label>
                <input
                  type="date"
                  className="form-control"
                  onChange={handelFilterChange}
                  name="startDate"
                />
              </div>
              <div className="form-group">
                <label htmlFor="">تاريخ النهايه </label>
                <input
                  type="date"
                  className="form-control"
                  onChange={handelFilterChange}
                  name="endDate"
                />
              </div>

              <div className="form-group">
                <label htmlFor=""> بدايه تاريخ حاله الحجز</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={handelFilterChange}
                  name="startDate"
                />
              </div>

              <div className="form-group">
                <label htmlFor=""> نهايه تاريخ حاله الحجز</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={handelFilterChange}
                  name="endDate"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn_style">
                  تصفيه
                </button>
              </div>
            </form>
          </div>

          {userRole == 0 ? (
            <div className="empty_complete d-flex align-items-center justify-content-start">
              <button className="btn btn_style" onClick={emotyCompleteCourses}>
                تفريغ الحجوزات
              </button>
              <button
                className="btn btn_style"
                style={{ marginRight: "20px" }}
                onClick={downloadData}
              >
                تحميل البيانات
              </button>
            </div>
          ) : null}

          <DataGridDemo
            selectionRows={selectionRows}
            coulmns={coulmns}
            rows={modifiedArray}
            handleRowSelection={handleRowSelection}
            adminUser={adminUser}
          />

          <Pagination
            showFirstButton
            showLastButton
            count={pageCount}
            page={page}
            onChange={handleChange}
            color="primary"
            className="paginaitonMod"
          />
        </div>
      </div>
    </>
  );
}

export default CourseComplete;
